export default {
  data:{}, //объект карточек которые отрусовывать в КОМАНДЕ
  dataUsers: [], //массив выделенных пользователей
  page: 1, // актиная страница по default 1 ( первые 40 записей)
  searchText: '', // поле поиска
  searchProfile: '',
  searchDates: '',
  searchStatus: '',
  loading: false
}


